export default __webpack_public_path__ + "static/media/zingPcv2@2x.5f774b71.png";